import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';
import { ManageImpersonation } from './ManageImpersonation';

const useStyles = makeStyles((theme) => ({
  marginTop: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      marginTop: theme.spacing(1)
    }
  }
}));

export const ManageGeneral = () => {
  const classes = useStyles();

  return (
    <div className={classes.marginTop}>
      <ManageImpersonation />
    </div>
  );
};